import { useCallback, useEffect, useState } from 'react';
import { fetchFinances, type FinanceSummary } from '@/services/finances';

const EMPTY: FinanceSummary = {
  todaySalesTotal: 0,
  monthSalesTotal: 0,
  totalCommissions: 0,
  totalDonations: 0,
  accumulatedDonations: 0,
  totalStock: 0,
  inventoryValue: 0,
  inventoryCost: 0,
  saleCount: 0,
  commissionPercent: 5,
  donationPercent: 2,
  totalExpenses: 0,
  totalPayments: 0,
  movementCount: 0,
  shippingOperationalCost: 0,
  grossSalesTotal: 0,
  cogsTotal: 0,
  marketingInvestment: 0,
  capitalNeto: 0,
  pendingCommissions: 0,
  refundedReturns: 0,
  shippingCollected: 0,
  premiumShippingAbsorbed: 0,
  shippingPaidCost: 0,
  shippingMargin: 0,
};

export function useFinances() {
  const [data, setData] = useState<FinanceSummary>(EMPTY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchFinances()
      .then((res) => {
        if (cancelled) return;
        setData(res.data);
      })
      .catch((err) => {
        if (cancelled) return;
        setData(EMPTY);
        setError(err instanceof Error ? err.message : 'Error al cargar las finanzas');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  const refetch = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  return { data, loading, error, refetch };
}